import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { QueryKeys } from '../keys';
import { request } from '../request';

export const useHeartbeat = () => {
  const { data } = useQuery({
    queryKey: QueryKeys.misc.heartbeat,
    queryFn: async () => {
      const response = await request('/ping');

      const { apiVersion } = z.object({ apiVersion: z.string() }).parse(response);

      return { apiVersion };
    },
    refetchInterval: 15 * 1000,
    refetchIntervalInBackground: true,
    retry: false,
  });

  return { apiVersion: data?.apiVersion ?? null };
};
